import { configureStore } from '@reduxjs/toolkit'
import roulleteReducer from "./B2bslice"

 const store = configureStore({
  reducer: {
    admin:roulleteReducer
  },
})
export { store };